import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {Field, reduxForm} from 'redux-form';
import {SelectInput} from 'admin-on-rest';
import {filterStyles} from '../shared/styles-filter';
import {viewStyles} from '../shared/styles-view';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

/**
 * Set a field for filter entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
        />
    )
};

class LocationInventoryLevelsSearchFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            includeProduct: false
        };
    }

    updateSign = (e, index, value) => {
        if (index === 'zero') {
            this.setState({
                includeProduct: false
            });
        }
    };

    updateIncludeProduct = (e, index, value) => {
        this.setState({
            includeProduct: index
        });
    };

    handleFilterSubmit = () => {
        if (typeof this.props.onSubmitFilter === 'function') {
            const includeProduct = (this.props.filterSign === 'zero') ? false : this.state.includeProduct;
            this.props.onSubmitFilter({
                includeProduct: includeProduct,
                searchName: (this.props.filterSign !== 'zero' && includeProduct) ? this.props.filterSearch : '',
                sign: this.props.filterSign
            });
        }
    };

    isDisabled = (props) => {
        const {
            filterSearch,
            filterSign,
            loading
        } = props;

        const {
            includeProduct
        } = this.state;

        return (
            loading ||
            filterSign === '' ||
            (filterSign !== 'zero' && includeProduct === true && (
                !filterSearch ||
                filterSearch === '' ||
                filterSearch.length < 3
            ))
        );
    };

    render() {
        const {
            filterSign
        } = this.props;

        const {
            includeProduct
        } = this.state;

        const styles = {
            selectContainer: {display: 'inline-block', marginRight: 10, marginBottom: '-1px', verticalAlign: 'bottom'}
        };

        const allowSearch = (filterSign !== 'zero');
        const disabled = this.isDisabled(this.props);

        return (
            <form>
                <div className="list-filter">
                    <span style={styles.selectContainer}>
                        <Field
                            name="filter_sign"
                            component={SelectInput}
                            choices={[
                                {id: 'positive', name: 'Positive Inventory'},
                                {id: 'negative', name: 'Negative Inventory'},
                                {id: 'zero', name: 'Zero Inventory'}
                            ]}
                            defaultValue="positive"
                            label="Inventory Level"
                            onChange={this.updateSign}
                            elStyle={viewStyles.rowShowFieldWide}
                        />
                    </span>
                    <span style={(allowSearch) ? filterStyles.checkbox : filterStyles.hidden}>
                        <Checkbox
                            name="filter_include_product"
                            label="Include Product Search?"
                            checked={includeProduct}
                            onCheck={this.updateIncludeProduct.bind(this)}
                            iconStyle={{marginRight: 6}}
                            labelStyle={{color: '#999999'}}
                        />
                    </span>
                    <Field
                        id="filter_search"
                        name="filter_search"
                        type="text"
                        component={renderInput}
                        floatingLabelText="Enter a Product Name (optional)"
                        style={(allowSearch && includeProduct) ? filterStyles.textInputWide : filterStyles.hidden}
                    />
                    <RaisedButton
                        primary
                        type="button"
                        label="Search"
                        disabled={disabled}
                        onClick={this.handleFilterSubmit}
                        style={filterStyles.submitButton}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['filterForm'];
    if (form && form.values) {
        return {
            filterSearch: form.values.filter_search,
            filterSign: form.values.filter_sign
        }
    }
    return {
        filterSearch: '',
        filterSign: ''
    }
};

LocationInventoryLevelsSearchFilter.propTypes = {
    loading: PropTypes.bool,
    onSubmitFilter: PropTypes.func
};

const enhance = compose(
    connect(
        mapStateToProps
    ),
    reduxForm({
        form: 'filterForm'
    })
);

export default enhance(LocationInventoryLevelsSearchFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationInventoryLevelsSearchFilter.js